import React, {Component} from 'react';

import Form from '../../../../components/form/ui-semantic-form';
import FormElement from '../../../../components/form/ui-semantic-form-elements';

export default class AddGroupProducts extends Component {
  constructor(props) {
    super(props);

    this.state = {
			isLoading: false,
			products: [{
        product_id: null,
        width: '',
        length: '',
        quantity: 1,
        is_lamination: 0,
        lamination_id: '',
        norm: 0,
        m2: 0
      }],
			countProducts: 1,
		};
  }

  removeThisModal() {
    this.props.removeModal();
  }

  addProduct () {
		let products = this.state.products,
			countProducts = 0;

		products.push({
			product_id: null,
            width: '',
            length: '',
            quantity: 1,
            norm: 0,
            is_lamination: 0,
            lamination_id: '',
            m2: 0,
            weight: 0,
            price: 0,
        });

		this.state.products.map(function(result, index) {
			if(result != undefined)
				countProducts++
		});

        this.setState({
        	products,
        	countProducts
        });
	}

	handleKeyPress (e) {
		if (e.charCode == 13){
			e.preventDefault();
			this.addProduct();
		}
	}

	removeProduct (key) {
    let products = [],
      countProducts = 0;

		this.state.products.map(function(result, index) {
			if(index != key){
				products[index] = result;
        countProducts++;
      }
		});

		this.setState({
			products,
      countProducts
		});
	}

  validationProducts () {
		if(this.state.products.length == 0 || this.state.products.length>100)
			return false;
		else
			return true;
	}

  changeDataLamination (key, models) 
	{
		let products = this.state.products,
				value = models['OrderProduct['+key+'][is_lamination]'].state.value;

		products[key].is_lamination = value;

		if(!value) {
			products[key].lamination_id = 0;
			models['OrderProduct['+key+'][lamination_id]'].setState({
				value: 0
			});
			models['OrderProduct['+key+'][lamination_id]'].state.value = 0;
			this.changeData(key, models);
		}

		// update state
		this.setState({
			products
		});
	}

  render() {
    return (
      <div id="form-add-order" style={{'width' : '100%'}}>
        <Form
          url="customer/order-create"
          loading={this.state.isLoading}
          action={(form) => this.props.actionAddProducts(this.removeThisModal.bind(this), form, this.state.countProducts)}
          onSuccess={this.onSuccess}
          beforeSend={this.validationProducts.bind(this)}
          buttonSubmitTitle="Dodaj do zlecenia">
          <div className="ui grid">
            <div className="sixteen wide column">
              <FormElement
                type="select"
                name={"product_id"}
                title="Proszę wybrać grubość pozycji"
                options={this.props.avaibleProducts}
                placeholder="wybierz..."
                validations="isLength:1"
                value={''}
                required
              />
              <button type="button" className="ui blue button add-product" onClick={this.addProduct.bind(this)}>
                Dodaj pozycję <i className="add square icon"></i>
              </button>
            </div>
            <div className="wrap-order-products">
              <table className="ui celled table order-products">
                <thead>
                  <tr>
                    <th style={{'width' : '100px'}}>Szerokość (mm)</th>
                    <th style={{'width' : '100px'}}>Długość (mm)</th>
                    <th style={{'width' : '50px'}}>Ilość</th>
                    <th style={{'width' : '70px'}}>Laminacja</th>
                    <th style={{'width' : '70px'}}>Znaczek</th>
                    <th className="center" style={{'width' : '70px'}}>Usuwanie</th>
                  </tr>
                </thead>
                <tbody>
                  {
                    this.state.products.map(function(result, index) {
                      return (
                        <tr key={index}>
                          <td>
                          <FormElement
                            type="text"
                            name={'OrderProduct['+index+'][width]'}
                            value={result.width}
                            validations="isLength:1"
                            maxlength="4"
                            index={index}
                            autofocus={true}
                            required
                          />
                          </td>
                          <td>
                          <FormElement
                            type="text"
                            name={'OrderProduct['+index+'][length]'}
                            value={result.length}
                            validations="isLength:1"
                            maxlength="4"
                            index={index}
                            required
                          />
                          </td>
                          <td>
                          <FormElement
                            type="text"
                            name={'OrderProduct['+index+'][quantity]'}
                            value={result.quantity}
                            validations="isLength:1"
                            index={index}
                            keyPress={this.handleKeyPress.bind(this)}
                            required
                          />
                          </td>
													<td style={{textAlign : 'center'}}>
															<div style={{float : result.is_lamination || result.lamination_id > 0 ? 'left' : 'none', 'margin' : result.is_lamination || result.lamination_id > 0 ? '6px 0 0 0' : '0px'}}>
																<FormElement
																	type="checkbox"
																	name={'OrderProduct['+index+'][is_lamination]'}
																	value={result.lamination_id > 0 ? 1 : 0}
																	validations="isLength:1"
																	change={this.changeDataLamination.bind(this)}
																	index={index}
																	required
																/>
															</div>
															<div style={{float : 'right'}} className="field-lamination_id">
																{ result.is_lamination || result.lamination_id > 0 ?
																<FormElement
																	type="select"
																	name={'OrderProduct['+index+'][lamination_id]'}
																	options={this.props.avaibleLaminations}
																	value={result.lamination_id}
																	placeholder="folie..."
																	index={index}
																	validations="isLength:1"
																	required
																/>
																: null
																}
															</div>
													</td>
                          <td className="norm">
                          <FormElement
                            type="checkbox"
                            name={'OrderProduct['+index+'][norm]'}
                            value={result.norm}
                            validations="isLength:1"
                            required
                          />
                          </td>
                          <td className="center">
                            <i className="remove circle outline icon red" onClick={() => this.removeProduct(index)}></i>
                          </td>
                        </tr>
                      );
                    }.bind(this))
                  }
                </tbody>
              </table>
            </div>
        </div>
        </Form>
      </div>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./js/views/customer/order/modals/AddGroupProducts.js
 **/